import { convertOldBreadcrumbProps } from '../../components/breadcrumb/converter.old';
import type { OldBreadcrumbProps } from '../../components/breadcrumb/converter.old';
import type { PageHeaderProps as PageHeaderNewProps } from './PageHeader';

export interface OldPageHeaderProps extends Omit<PageHeaderNewProps, 'bordered' | 'breadcrumbProps'> {
  /** @deprecated bordered를 대신 사용해주세요. */
  border?: boolean;
  breadcrumbProps?: OldBreadcrumbProps;
}

export function convertOldPageHeaderProps({
  border,
  breadcrumbProps,
  ...props
}: OldPageHeaderProps): PageHeaderNewProps {
  return {
    ...props,
    bordered: border,
    ...(breadcrumbProps ? { breadcrumbProps: convertOldBreadcrumbProps(breadcrumbProps) } : {}),
  };
}
